export default __webpack_public_path__ + "static/media/Vehiculo.78813f9a.png";